/* eslint-disable @stylistic/comma-dangle */

import { messages as commonLocale }	from "@geotoura/common/locale_it";
import { siteInfo }					from "@geotoura/shared/siteInfo_it";
import { sharedLocale }				from "@geotoura/shared/sharedLocale_it";

export const messages = {
	general: {
		and:			"e",
		cancel:			"Interrompi",
		category:		"Categoria",
		close:			"Chiudi",
		closeDialog:	"Chiudi finestra",
		defHotel:		"Località con alberghi selezionati",
		defDaytrip:		"Destinazione",
		defAirport:		"Luoghi con aeroporto",
		help:			"Aiuto",
		impressum:		{ href: siteInfo.page.impressum, text: "Cronologia" },
		night:			"Notte",
		nights:			"Notti",
		remove:			"Elimina",
		stop:			"Fermata",
		stops:			"Fermate",
	},
	activitylist: {
		title:	"Esperienze",
		intro:	"Per noi, un viaggio perfetto include non solo hotel selezionati, ma anche esperienze uniche. È possibile prenotare le seguenti offerte quando si visita questa città.",
	},
	app: {
		contentShow:	"Mostra informazioni",
		contentHide:	"Chiudi informazioni",
	},
	counter: {
		up:		"aumenta di uno",
		down:	"diminuisci di uno"
	},
	destination: {
		scrollTop:	"In alto, all’inizio"
	},
	destinationInfo: {
		addToRoute:			"Aggiungi al mio itinerario",
		addToRouteShort:	"Nel mio itinerario",
		removeFromRoute:	"Elimina dal mio itinerario",
		station:			(nr:string):string => `Stazione ${nr}`,
		stationSuffix:		" dell’itinerario",
		removeInRoute:		"elimina e modifica con il luogo successivo",
		nights: {
			nrnights:				"Pernottamenti",
			nrnightsShort:			"Notti",
			recommendedStay:		"Il nostro consiglio: ",
			recommendedStayShort:	"Il nostro suggerimento:",
			labelPlus:				"Aumenta di una notte",
			labelMinus:				"Diminuisci di una notte",
		}
	},
	footer: [
		{ href: siteInfo.page.privacy,		text: "Protezione dei dati" },
		{ href: siteInfo.page.arb,			text: "Condizioni generali di viaggio" },
		{ href: siteInfo.page.impressum,	text: "Cronologia" }
	],
	gallery: {
		fotos: "Foto",
	},
	hotel: {
		selectCategory:	"Seleziona hotel",
		selected:		"Hotel selezionato"
	},
	hotelFeatured: {
		note:			"Nota",
		severalCats:	"Questo hotel appare in diverse categorie di hotel perché ha camere per diverse esigenze di qualità."
	},
	hotelList: {
		title:		"Hotel",
		catIntro:	"Quando includiamo un hotel nel nostro programma, non è solo per un alto standard di qualità che è importante per noi. Preferiamo un alloggio che sia tipico del paese e che abbia un ambiente speciale. Dividiamo i nostri hotel in quattro categorie proprie di Geotoura.",
		cat1:		"La nostra opzione più conveniente. Camere amorevolmente arredate che offrono tutto ciò che il viaggiatore esigente si aspetta",
		cat2:		"Alberghi con un ambiente speciale: palazzi storici, monasteri, haciendas o hotel sulla spiaggia dal fascino eccezionale. Perfetto per il classico tour culturale",
		cat3:		"Hotel di lusso in posizioni eccellenti e con il più alto livello di comfort, spesso in palazzi aristocratici secolari, vecchi frantoi o haciendas.",
		cat4:		"Per la luna di miele (in spagnolo: Luna de miel) o se volete concedervi qualcosa di straordinario …",
	},
	help: {
		title:	"Cosi funziona il pianificatore di viaggi Geotoura",
		step1: {
			title:	"Seleziona le tue destinazioni preferite sulla mappa",
		},
		step2: {
			title:	"Aggiungi le località al tuo itinerario",
			text:	"Scegli tra le nostre proposte di hotel ed eventi dove andare, cosa visitare e cosa sperimentare.",
		},
		step3: {
			title:	"Richiedi gratuitamente la nostra proposta di viaggio",
			text:	"Ti invieremo via e-mail un’offerta gratuita e non vincolante per il tuo viaggio individuale su misura.",
		},
		outro:			"Se alla fine tutto corrisponde, puoi prenotare esattamente questo viaggio con noi, ci prendiamo cura di tutto: volo, auto a noleggio, hotel e tutti i piccoli extra che rendono speciale un viaggio con Geotoura.",
		buttonTitle:	"Si parte!"
	},
	howtoStart: {
		title:	"La vacanza dei tuoi sogni, proprio come piace a te",
		step1: {
			title:			"Selezione dell’itinerario",
			withoutRoute:	"senza itinerario",
		},
		step2: {
			title:	"Personalizzate le vostre fermate",
			text:	"Hotels, escursioni ed esperienze, scegli tra i nostri consigli, secondo i tuoi desideri",
		},
		step3: {
			title:	"Richiedi il tuo itinerario da sogno",
			text:	"Riceverai via e-mail la nostra proposta gratuita e non vincolante, creata su misura per te.",
		},
		outro:			" Una volta che avrai selezionato il tuo viaggio da sogno, ci occuperemo di tutto il resto: volo, auto a noleggio, hotel e tutti i piccoli extra che rendono speciale un viaggio con Geotoura Italia.",
		buttonTitle:	"Pianifica il tuo percorso ora"
	},
	howtoHelp: {
		title:	"Così funziona il pianificatore di viaggi Geotoura",
		step1: {
			title:	"Seleziona le tue destinazioni preferite sulla mappa",
		},
		step2: {
			title:	"Aggiungi le località al tuo itinerario",
			text:	"Scegli tra le nostre proposte di hotel ed eventi dove andare, cosa visitare e cosa sperimentare.",
		},
		step3: {
			title:	"Richiedi gratuitamente la nostra proposta di viaggio",
			text:	"Ti invieremo via e-mail un’offerta gratuita e non vincolante per il tuo viaggio individuale su misura.",
		},
		outro:			"Se alla fine tutto corrisponde, puoi prenotare esattamente questo viaggio con noi, ci prendiamo cura di tutto: volo, auto a noleggio, hotel e tutti i piccoli extra che rendono speciale un viaggio con Geotoura..",
		buttonTitle:	"Si parte!"
	},
	legend: {
		title:	"Leggenda",
	},
	lightbox: {
		title:		"Lightbox",
		previous:	"Mostra immagine precedente",
		next:		"Mostra immagine successiva"
	},
	nearbylist: {
		title:	"La prossima destinazione di vacanza"
	},
	nearby: {
		hintHotel:		"In questo luogo offriamo alberghi",
		hintDaytrip:	"Un’interessante escursione giornaliera",
	},
	overwriteRoute: {
		title:				"Itinerario salvato trovato",
		message1:			"Sei arrivato qui tramite un link che salva e mostra l’itinerario creato da Geotoura.",
		message2:			"Nel tuo browser è già presente un’itinerario ",
		message3:			"Salvato da una visita precedente del pianificatore di viaggio. Con quale itinerario desideri proseguire?",
		cancelTitle:		"Mantenere l’itinerario salvato",
		confirmTitle:		"Carica itinerario Geotoura",
	},
	territorylist: {
		entryUrl:	siteInfo.page.main,
		intro:		"Dove desideri andare?",
		logo:		"logo-white-IT.svg"
	},
	request: {
		title:				"Richiedo una proposta di viaggio",
		buttonRequest:		"Richiedere un’offerta gratuita e non vincolante",
		buttonRequestShort:	"Richiedere un’offerta gratuita",
		buttonCancel:		"Interrompi",
	},
	form: commonLocale.form,
	requestform: {
		flight: {
			labelChecked:	"Prego pianificare la mia partenza da",
			label:			"Prego pianificare la mia partenza"
		},
		postCode:{
			label:			"CAP",
			placeholder:	"CAP",
		},
		country:{
			label:	"Nazione",
		},
		nrAdults: {
			label:	"Adulti"
		},
		nrBabies: {
			label:	"Infant (0-2 anni)"
		},
		kids:	"Bambini",
		nrKids: {
			label:	"Bambini (3-11 anni)"
		},
		roomSingle: {
			label:	"Camera singola"
		},
		roomDouble: {
			label:	"Camera doppia"
		},
		kidBeds: {
			label:	"Letti aggiuntivi"
		},
		babyBeds: {
			label:	"Culle"
		},
		duration: {
			label:	"Durata del viaggio"
		},
		startIntro:	"Desidero viaggiare tra",
		start: {
			label:	"Data inzio",
		},
		end: {
			label:	"Data fine",
		},
		rentalCar: {
			label:	"Prego organizzare un’auto a noleggio"
		},
		rentalCarCategory: {
			label:	"Categoria dell’auto"
		},
		hotelCategory: {
			label:	"Categoria dell’albergo"
		},
		notes: {
			label:			"Note",
			placeholder:	"Hai ancora richieste speciali, per esempio di accessibilità o altre necessità per la tua vacanza? Li puoi richiedere qui.",
		},
	},
	requestroute: {
		title:		"Itinerario di viaggio",
		noOffer:	"Non hai ancora scelto la tua destinazione. Configura il tuo viaggio da sogno personale nella pagina precedente, o scrivici i tuoi commenti e saremo felici di aiutarti ulteriormente.",
		show:		"Mostra dettagli",
		hide:		"Nascondi dettagli"
	},
	requestSuccess: {
		title:		"Grazie per la tua richiesta",
		text1:		"A breve dovresti ricevere un’e-mail di conferma con i dettagli del tuo viaggio. Un membro del nostro staff userà i tuoi dati per creare un’offerta di viaggio individuale per te..",
		text2:		"Di solito rispondiamo entro 24 ore. Durante il fine settimana i tempi di risposta potrebbero durare un po’ di più. Rispondiamo a tutte le richieste del fine settimana a partire dal lunedì mattina..",
		text3:		"Il tuo itinerario rimane salvato nel tuo browser in modo che tu possa visualizzarlo e modificarlo in un secondo momento.",
		greetings:	"Tanti Saluti dal centro storico di Taormina",
		signature:	"Il tuo Team Geotoura",
	},
	requestError: {
		title:	"Errore durante l’invio",
		text:	"Purtroppo si è verificato un errore durante l’invio e la tua richiesta non è stata inviata. Tuttavia, il tuo itinerario rimane salvato nel tuo browser. Prego riprovare più tardi o contattarci direttamente a",
		link:	sharedLocale.phone,
	},
	routeDelete: {
		title:			"Eliminare definitivamente l’itinerario?",
		message:		"Quest’azione cancella il tuo intero itinerario.",
		confirmTitle:	"Elimina itinerario"
	},
	route: {
		title:		"Il mio itinerario",
		stop:		"Fermata",
		stops:		"Fermate",
		night:		"Pernottamento",
		nights:		"Pernottamenti",
		activity:	"Esperienza",
		activities:	"Esperienze",
		wish:		"Desiderio",
		wishes:		"Desideri",
		clearRoute:	"Elimina l’intero itinerario",
		request:	"Richiedi un’offerta",
		empty:		"Ancora non hai inserito nessuna fermata al tuo itinerario. Seleziona una destinazione sulla mappa per aggiungere le fermate al tuo itinerario!",
		back:		"Ritorna alla mappa",
	},
	routebar: {
		showRoute:			"Mostra itinerario",
		hideRoute:			"Nascondi itinerario",
		showDestination:	"Mostra descrizione del luogo",
		hideDestination:	"Nascondi descrizione del luogo",
		summary: {
			stops:		"Fermate",
			hotels:		"Notti",
			activities:	"Esperienze",
			wishes:		"Desideri",
			request:	"Offerta",
		},
		station:		"Fermata",
		currentStation:	"Luogo attuale",
		previous:		"Al luogo precedente dell’itinerario",
		next:			"Al prossimo luogo dell’itinerario",
		back:			"Ritorna alla pagina iniziale Geotoura"
	},
	routestop: {
		wish:				"Desideri",
		removeWish:			"Rimuovi desiderio",
		removeActivity:		"Rimuovi esperienza",
		activeDestination:	"Destinazione attuale",
		addToRoute:			"Aggiungi all’itinerario",
		moveUp:				"Sposta su",
		moveDown:			"Sposta giù",
		showDestination:	"Alla descrizione del luogo"
	},
	search: {
		placeholder:	"Cerca luogo",
		label:			"Cerca luogo",
		noMatches:		"Nessun risultato per la tua ricerca",
		clearInput:		"Elimina inserimento"
	},
	sights: {
		show:		"più informazioni",
		hide:		"meno informazioni",
		h3Title:	"Maggiori dettagli sul luogo"
	},
	wish: {
		title:			"Desideri speciali",
		info:			"Scrivici quello che vorresti fare o le esperienze da vivere; il nostro staff, che conosce il paese, lo organizzerà per te.",
		placeholder:	"Vorresti organizzato qualcosa di particolare in questa località? Un concerto, una serata all’opera o un picnic nel parco? Qui c’è spazio per i tuoi desideri …",
		add:			"Aggiungi desiderio all’itinerario",
		change:			"modifica",
		label:			"Desiderio",
	},
};
